import { Grid } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Field, reduxForm } from "redux-form";

import { withTrackProps } from "@dpdgroupuk/react-event-tracker";

import { ReactComponent as Locked } from "../../../../assets/icons/locked.svg";
import { ReactComponent as Unlocked } from "../../../../assets/icons/unlocked.svg";
import { CheckBox } from "../../../../components/CheckBox/CheckBox.js";
import InputWithTitle from "../../../../components/InputWithTitle/InputWithTitle.js";
import SelectWithTitle from "../../../../components/SelectWithTitle/SelectWithTitle.js";
import SvgIconComponent from "../../../../components/SvgIcon/svgIcon.js";
import CustomSwitchWithTitle from "../../../../components/SwitchWidthTitle/CustomSwitchWithTitle";
import {
  ANALYTICS_FOR_USER,
  CREATE_CUSTOMER_USER,
  CREATE_EDIT_CUSTOMER_USER_ANALYTICS,
} from "../../../../constants/analytics";
import { USER_DETAILS_FORMS } from "../../../../constants/forms";
import {
  CHOOSE_AUTOGENERATED_USERNAME,
  CONFIRM_PASSWORD,
  DESCRIPTION,
  EMAIL_ADDRESS,
  FIRST_NAME,
  LOGON_DETAILS,
  PASSWORD,
  POSITION,
  SURNAME,
  TEL_NUMBER,
  TITLE,
  USERNAME,
} from "../../../../constants/strings.js";
import {
  EMAIL_FIELD,
  RE_ENTER_PASSWORD_FIELD,
} from "../../../../features/myDpdUserForm/userDetails/userDetails.constants";
import { asyncValidate } from "../../../../features/myDpdUserForm/userDetails/userDetails.validate.js";
import { getGeneratedUsernames } from "../../../../features/user/user.selectors";
import { getSelectedAccountId } from "../../../../features/userDetailsForm/accountDetails/accountDetails.selectors";
import {
  AUTOGENERATED_USERNAME_FIELD,
  DESCRIPTION_FIELD,
  FORENAME_FIELD,
  LASTNAME_FIELD,
  NEW_PASSWORD_FIELD,
  PASSWORD_LOCK_FIELD,
  PHONE_FIELD,
  POSITION_FIELD,
  TITLE_FIELD,
  TITLE_OPTIONS,
  USERNAME_FIELD,
} from "../../../../features/userDetailsForm/userDetails/userDetails.constants";
import {
  getUserId,
  isAutoGeneratedUsername,
  isUseEmailAsLoginEnabled,
} from "../../../../features/userDetailsForm/userDetails/userDetails.selectors";
import { validate } from "../../../../features/userDetailsForm/userDetails/userDetails.validate";
import { changeUsername } from "../../../../features/userDetailsForm/userDetailsForm.actions.js";
import { getAdminAccess } from "../../../../features/userDetailsForm/userDetailsForm.selector.js";
import withErrorTooltip from "../../../../hocs/withErrorTooltip/index.js";
import withRef from "../../../../hocs/withRef.js";
import { isEmailValid } from "../../../../utils/commonValidation";
import { withoutSpaces } from "../../../../utils/normalize";
import styles from "./UserDetailsForm.module.scss";
const SwitchWithError = withErrorTooltip(CustomSwitchWithTitle);
const DecoratedFieldWithError = withErrorTooltip(InputWithTitle);
const DecoratedSelectWithError = withErrorTooltip(SelectWithTitle);

const UserDetailsForm = ({
  onPasswordLock,
  onBlurFields,
  adminAccess,
  isEdit,
  isEmailUsedAsLogin,
  isGenerateUsername,
  onEmailChange,
  onTitleChange,
  usernames = [],
  accountId,
  generatedUsernames,
  onSelectUsername,
}) => (
  <div>
    <Grid container className={styles.profile}>
      <Grid item className={styles.title}>
        <Field
          component={SelectWithTitle}
          name={TITLE_FIELD}
          label={TITLE}
          onChange={onTitleChange}
        >
          <MenuItem value={TITLE_OPTIONS.MR.value}>
            <Typography className={styles["title-text"]}>
              {TITLE_OPTIONS.MR.label}
            </Typography>
          </MenuItem>
          <MenuItem value={TITLE_OPTIONS.MRS.value}>
            <Typography className={styles["title-text"]}>
              {TITLE_OPTIONS.MRS.label}
            </Typography>
          </MenuItem>
          <MenuItem value={TITLE_OPTIONS.MISS.value}>
            <Typography className={styles["title-text"]}>
              {TITLE_OPTIONS.MISS.label}
            </Typography>
          </MenuItem>
          <MenuItem value={TITLE_OPTIONS.MS.value}>
            <Typography className={styles["title-text"]}>
              {TITLE_OPTIONS.MS.label}
            </Typography>
          </MenuItem>
        </Field>
      </Grid>
      <Grid item className={styles.position}>
        <Field
          name={POSITION_FIELD}
          component={InputWithTitle}
          icon={<SvgIconComponent name={POSITION_FIELD} />}
          label={POSITION}
          onBlur={() => onBlurFields(POSITION_FIELD)}
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
      <Grid item className={styles["profile-item"]}>
        <Field
          name={FORENAME_FIELD}
          component={InputWithTitle}
          icon={<SvgIconComponent name="profile" />}
          inputProps={{ maxLength: 35 }}
          label={FIRST_NAME}
          onBlur={() => onBlurFields(FORENAME_FIELD)}
          blurNormalize={withoutSpaces}
        />
      </Grid>
      <Grid item className={styles["profile-item"]}>
        <Field
          name={LASTNAME_FIELD}
          component={InputWithTitle}
          icon={<SvgIconComponent name="profile" />}
          inputProps={{ maxLength: 35 }}
          label={SURNAME}
          onBlur={() => onBlurFields(LASTNAME_FIELD)}
          blurNormalize={withoutSpaces}
        />
      </Grid>
      <Grid item className={styles["profile-item"]}>
        <Field
          name={EMAIL_FIELD}
          component={DecoratedFieldWithError}
          icon={<SvgIconComponent name="email" />}
          label={EMAIL_ADDRESS}
          required={adminAccess}
          onChange={adminAccess && !isEdit && onEmailChange}
          normalize={withoutSpaces}
          onBlur={() => onBlurFields(EMAIL_FIELD)}
          disabled={isEdit && isEmailUsedAsLogin}
          inputProps={{ maxLength: 100 }}
        />
      </Grid>
      <Grid item className={styles["profile-item"]}>
        <Field
          name={PHONE_FIELD}
          component={DecoratedFieldWithError}
          icon={<SvgIconComponent name={PHONE_FIELD} />}
          label={TEL_NUMBER}
          onBlur={() => onBlurFields(PHONE_FIELD)}
          inputProps={{ maxLength: 15 }}
        />
      </Grid>
    </Grid>
    <Field
      name={DESCRIPTION_FIELD}
      component={InputWithTitle}
      icon={<SvgIconComponent name={DESCRIPTION_FIELD} />}
      label={DESCRIPTION}
      onBlur={() => onBlurFields(DESCRIPTION_FIELD)}
      inputProps={{ maxLength: 100 }}
    />
    {!isEdit ? (
      <Grid item className={styles.username}>
        <Field
          name={AUTOGENERATED_USERNAME_FIELD}
          component={SwitchWithError}
          type="checkbox"
          onChange={generatedUsernames}
          label={CHOOSE_AUTOGENERATED_USERNAME}
          disabled={!usernames.length || !accountId || adminAccess}
        />
      </Grid>
    ) : null}

    <Grid container>
      <Typography
        className={classNames(styles.text, isEdit && styles.editText)}
      >
        {LOGON_DETAILS}
      </Typography>
    </Grid>
    <Grid container className={styles.profile}>
      <Grid item className={styles["profile-item"]}>
        {isGenerateUsername && !isEdit && !adminAccess ? (
          <Field
            component={DecoratedSelectWithError}
            name={USERNAME_FIELD}
            containerStyles={styles["auto-generated-username"]}
            label={USERNAME}
            onChange={onSelectUsername}
            required={!adminAccess}
          >
            {usernames.map((name) => (
              <MenuItem value={name} key={name}>
                <Typography className={styles["title-text"]}>{name}</Typography>
              </MenuItem>
            ))}
          </Field>
        ) : (
          <Field
            name={USERNAME_FIELD}
            component={DecoratedFieldWithError}
            icon={<SvgIconComponent name="profile" />}
            label={USERNAME}
            onBlur={() => onBlurFields(USERNAME_FIELD)}
            required={!adminAccess}
            disabled={isEdit || adminAccess}
            normalize={withoutSpaces}
            inputProps={{ maxLength: 100 }}
          />
        )}
      </Grid>
      <Grid item container className={styles.password}>
        <Grid item container className={styles["password-lock"]}>
          <Grid item className={styles["new-password"]}>
            <Field
              name={NEW_PASSWORD_FIELD}
              component={DecoratedFieldWithError}
              disabled={adminAccess}
              icon={<SvgIconComponent name="password" />}
              label={PASSWORD}
              inputProps={{ maxLength: 100 }}
              onBlur={() => onBlurFields(NEW_PASSWORD_FIELD)}
              required={!isEdit && !adminAccess}
            />
          </Grid>
          <Grid item className={styles.lock}>
            <Field
              name={PASSWORD_LOCK_FIELD}
              component={CheckBox}
              type="checkbox"
              labelClasses={{ root: styles["checkbox-label"] }}
              icon={<Unlocked />}
              checkedIcon={<Locked />}
              disabled={adminAccess}
              onChange={onPasswordLock}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Field
            name={RE_ENTER_PASSWORD_FIELD}
            component={DecoratedFieldWithError}
            icon={<SvgIconComponent name="password" />}
            label={CONFIRM_PASSWORD}
            inputProps={{ maxLength: 100 }}
            onBlur={() => onBlurFields(RE_ENTER_PASSWORD_FIELD)}
            required={!isEdit && !adminAccess}
            disabled={adminAccess}
          />
        </Grid>
      </Grid>
    </Grid>
  </div>
);

UserDetailsForm.propTypes = {
  onBlurFields: PropTypes.func,
  onEmailChange: PropTypes.func,
  onTitleChange: PropTypes.func,
  onSelectUsername: PropTypes.func,
  generatedUsernames: PropTypes.func,
  onPasswordLock: PropTypes.func,
  usernames: PropTypes.array,
  isEdit: PropTypes.bool,
  adminAccess: PropTypes.bool,
  accountId: PropTypes.string,
  isEmailUsedAsLogin: PropTypes.bool,
  isGenerateUsername: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  adminAccess: getAdminAccess(state),
  isEdit: !!getUserId(state),
  usernames: getGeneratedUsernames(state),
  isGenerateUsername: isAutoGeneratedUsername(state),
  isEmailUsedAsLogin: isUseEmailAsLoginEnabled(state),
  accountId: getSelectedAccountId(state),
});

const mapDispatchToProps = (dispatch) => ({
  onEmailChange: (event, value) =>
    isEmailValid(value) && dispatch(changeUsername(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: USER_DETAILS_FORMS.DPD_USER_DETAILS,
    validate,
    asyncValidate,
    shouldAsyncValidate: () => true,
    asyncBlurFields: [USERNAME_FIELD, "email"],
  }),
  withTrackProps(() => ({
    onTitleChange: () =>
      CREATE_EDIT_CUSTOMER_USER_ANALYTICS.CLICK_TITLE_DROPDOWN,
    onPasswordLock: (event) => {
      if (event.target.checked) {
        return ANALYTICS_FOR_USER.CLICK_PADLOCK_TO_LOCK_PASSWORD;
      }
    },
    generatedUsernames:
      CREATE_CUSTOMER_USER.TOGGLE_SELECT_AUTO_GENERATED_USERNAME_,
    onSelectUsername: CREATE_CUSTOMER_USER.CLICK_AUTO_USERNAME_DROPDOWN_LIST,
  })),
  withRef
)(UserDetailsForm);
